export const CREATE_PRODUCT_CATEGORY = "CREATE_PRODUCT_CATEGORY";
export const GET_ALL_PRODUCT_CATEGORY = "GET_ALL_PRODUCT_CATEGORY";
export const REMOVE_PRODUCT_CATEGORY = "REMOVE_PRODUCT_CATEGORY";
export const UPDATE_PRODUCT_CATEGORY = "UPDATE_PRODUCT_CATEGORY";
export const PRODUCT_CATEGORY_LOADING = "PRODUCT_CATEGORY_LOADING";
export const PRODUCT_CATEGORY_MODAL = "ProductCategoryModal";
